module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "button is-fullwidth",
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v("ДОБАВИТЬ ПО")]), _vm._v(" "), _c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [(_vm.showForm) ? _c('div', [_c('b-field', {
    attrs: {
      "label": "Название"
    }
  }, [_c('b-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.app.title),
      callback: function($$v) {
        _vm.$set(_vm.app, "title", $$v)
      },
      expression: "app.title"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "GrottBjörn ID"
    }
  }, [_c('b-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.app.sourceId),
      callback: function($$v) {
        _vm.$set(_vm.app, "sourceId", $$v)
      },
      expression: "app.sourceId"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Описание"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.app.description),
      expression: "app.description"
    }],
    staticClass: "textarea",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.app.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.app, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.showFileForm) ? _c('div', [_c('b-field', {
    attrs: {
      "label": "Файлы"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.app.files), function(fileItem, idx) {
    return _c('li', {
      key: fileItem.id
    }, [(fileItem.path) ? _c('a', {
      attrs: {
        "href": fileItem.path,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v(_vm._s(fileItem.title))]) : _c('span', [_vm._v(_vm._s(fileItem.title))]), _vm._v(" "), _c('span', {
      staticClass: "is-pulled-right"
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editFile(fileItem.id || idx)
        }
      }
    }, [_vm._v("Редактировать")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delFile(fileItem.id || idx)
        }
      }
    }, [_vm._v("Удалить")])])])
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.showFileForm) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.editFile()
      }
    }
  }, [_vm._v("Добавить файл")]) : _vm._e(), _vm._v(" "), (_vm.showFileForm) ? _c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('b-switch', {
    on: {
      "change": function($event) {
        return _vm.rerender()
      }
    },
    model: {
      value: (_vm.file.isLink),
      callback: function($$v) {
        _vm.$set(_vm.file, "isLink", $$v)
      },
      expression: "file.isLink"
    }
  }, [_vm._v("Это ссылка")])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Название"
    }
  }, [_c('b-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.file.title),
      callback: function($$v) {
        _vm.$set(_vm.file, "title", $$v)
      },
      expression: "file.title"
    }
  })], 1), _vm._v(" "), (_vm.file.isLink) ? _c('b-field', {
    attrs: {
      "label": "Ссылка на файл"
    }
  }, [_c('b-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.file.link),
      callback: function($$v) {
        _vm.$set(_vm.file, "link", $$v)
      },
      expression: "file.link"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.file.isLink && _vm.file.path) ? _c('b-field', {
    attrs: {
      "label": "Текущий файл"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.file.path) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.file.isLink) ? _c('b-field', {
    attrs: {
      "label": _vm.fileExist ? 'Новый файл' : 'Файл'
    }
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.setFile
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-fullwidth is-success",
    on: {
      "click": _vm.saveFile
    }
  }, [_vm._v(_vm._s(_vm.fileExist ? 'СОХРАНИТЬ ФАЙЛ' : 'ДОБАВИТЬ ФАЙЛ'))]), _vm._v(" "), _c('button', {
    staticClass: "button is-fullwidth",
    on: {
      "click": _vm.resetFileForm
    }
  }, [_vm._v("ОТМЕНИТЬ")])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button is-fullwidth is-success",
    attrs: {
      "disabled": _vm.waiting
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.waiting ? 'Идет сохранение...' : 'СОХРАНИТЬ'))]), _vm._v(" "), _c('button', {
    staticClass: "button is-fullwidth",
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("ОТМЕНИТЬ")])], 1) : _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.apps), function(appItem) {
    return _c('li', {
      key: appItem.id,
      staticClass: "box",
      on: {
        "click": function($event) {
          return _vm.edit(appItem.id)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(appItem.title))]), _vm._v(" "), _c('button', {
      staticClass: "delete is-pulled-right",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.del(appItem.id)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(appItem.description))]), _vm._v(" "), _c('ul', _vm._l((appItem.files), function(item) {
      return _c('li', {
        key: item.id
      }, [_c('strong', [_vm._v(_vm._s(item.title))])])
    }), 0)])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e69b449"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Software/Item.vue
// module id = 953
// module chunks = 0